export default {
  appTitle: "نرم افزار اتوماتیک عیب یابی خطوط انتقال و فوق توزیع (AFTL)",
  appName: "سامانه AFTL",
  logoAlt: "لوگو AFTL",
  copyright:
    '© 1399 کلیه حقوق مادی و معنوی این نرم افزار متعلق به <a href="https://www.nri.ac.ir/" target="_blank" style="color: black;">پژوهشگاه نیرو</a> و شرکت دانش بنیان <a href="https://www.virakavir.com/" target="_blank" style="color: black;">فنی مهندسی داده کاوی ویراژرف کویر</a> می‌باشد.',
  loginToSystem: "ورود به سامانه",
  login: "ورود",
  userName: "نام کاربری",
  userNameExample: "مانند: 09123456789",
  password: "رمز ورود",
  capsLockIsOn: "توجه: کلید Caps Lock روشن است.",
  forgotPassword: "رمز عبور را فراموش کرده‌اید؟",
  welcome: "خوش آمدید",
  wrongUsernamePassword: "نام کاربری یا رمز ورود نادرست است.",
  version: "ویرایش",
  dashboard: "میزکار",
  message403: "شما به این صفحه دسترسی ندارید.",
  message404: "صفحه مورد نظر شما یافت نشد.",
  message500: "خطا در سرور",
  return: "برگشت",
  sendTAC: "ارسال کد موقت",
  sendTACDescription:
    "با ارسال این فرم یک کد موقت برای شما پیامک می‌شود که در صفحه بعد با وارد کردن آن و رمز ورود جدید، رمز ورود جدید شما جایگزین رمز ورود قبلی شما خواهد شد.",
  send: "بفرست",
  iHavePassword: "رمز ورود دارم.",
  iHaveTAC: "کد موقت دارم.",
  TACSent: "کد موقت برای شما ارسال شد.",
  newPassword: "رمز ورود جدید",
  TAC: "کد موقت",
  confirmNewPassword: "تائید رمز ورود جدید",
  save: "ذخیره کن",
  doNotHaveTAC: "کد موقت ندارم.",
  setNewPassword: "تعیین رمز ورود جدید",
  newPasswordSaved: "رمز ورود جدید شما ذخیره شد.",
  changeTheme: "تغییر حالت شب و روز",
  resizeMenu: "تغییر اندازه منو",
  profile: "مشخصات",
  activities: "فعالیت‌ها",
  signOut: "خروج",
  dashboardToolTip: "خلاصه آمار",
  employers: "کارفرماها",
  employersToolTip: "مدیریت کارفرماها، پیمانکاران، خط‌ها و برج‌ها",
  users: "کاربرها",
  usersToolTip: "مدیریت کاربرها",
  activitiesToolTip: "جستجو در فعالیت‌های کاربران",
  images: "تصاویر",
  imagesToolTip: "تصاویر ارسال شده",
  searchImages: "جستجوی تصاویر",
  searchImagesToolTip: "جستجوی تصاویر ارسال شده",
  reports: "گزارش‌ها",
  reportsToolTip: "مدیریت گزارش‌ها",
  supportCenter: "مرکز پشتیبانی",
  supportCenterToolTip: "مرکز مدیریت پشتیبانی",
  models: "مدل‌ها",
  modelsToolTip: "مدیریت مدل‌ها",
  systemStatus: "وضعیت سیستم",
  systemStatusToolTip: "میزان مصرف منابع و وضعیت سرویس‌ها",
  logs: "لاگ‌ها",
  logsToolTip: "لاگ‌های سرور و سامانه",
  colleagues: "همکاران",
  colleaguesToolTip: "نمایش همکاران",
  contractors: "پیمانکاران",
  contractorsToolTip: "نمایش پیمانکاران",
  shootingGuide: "راهنمای تصویربرداری",
  shootingGuideToolTip: "فایل PDF نحوه تصویربرداری با پهپاد",
  uploadImages: "ارسال تصاویر",
  uploadImagesToolTip: "ارسال تصاویر",
  support: "پشتیبانی",
  supportToolTip: "پشتیبانی",
  about: "درباره",
  aboutToolTip: "درباره شرکت",
  changes: "تغییرات",
  changesToolTip: "تاریخچه تغییرات برنامه",
  changesTitle: "تاریخچه تغییرات",
  logout: "خروج",
  logoutTitle: "خروج از سامانه",
  lines: "خط‌ها",
  towers: "برج‌ها",
  searchActivities: "جستجوی فعالیت‌ها",
  continueUpload: "ادامه ارسال تصاویر",
  uploadedImages: "تصاویر ارسال شده",
  modelErrors: "خطاهای مدل",
  reportOnMap: "گزارش روی نقشه",
  batchImageOperations: "عملیات دسته تصاویر",
  reportOperations: "عملیات گزارش",
  requestSupport: "درخواست پشتیبانی",
  help: "راهنما",
  showHelp: "نمایش راهنما",
  dateFrom: "از تاریخ",
  dateTo: "تا تاریخ",
  updateStatistics: "بروزرسانی آمار",
  imagesWithWithoutErrors: "تعداد تصاویر با و بدون خطا",
  withError: "با خطا",
  withoutError: "بدون خطا",
  numberOfErrorTypes: "تعداد انواع خطاها",
  gotIt: "متوجه شدم",
  normal: "معمولی",
  warning: "هشدار",
  critical: "بحرانی",
  employersImages: "تعداد تصاویر کارفرماها",
  employer: "کارفرما",
  number: "تعداد",
  errorsFrequency: "فراوانی خطاها",
  error: "خطا",
  management: "مدیریت",
  system: "سامانه",
  low: "کم",
  medium: "متوسط",
  high: "زیاد",
  dashboardHelp:
    'این صفحه خلاصه آمار سامانه را به صورت پیش فرض در بازه زمانی یک هفته گذشته نمایش می‌دهد. جهت مشاهده آمار در بازه زمانی دلخواه ابتدا بازه زمانی را انتخاب کرده و سپس دکمه "بروزرسانی آمار" را انتخاب کنید.',
  viraName: "شرکت فنی مهندسی داده کاوی ویراژرف کویر",
  viraIntro:
    "با کادری مجرب و متخصص (متشکل از برترین اساتید دانشگاه و مهندسین خبره صنعت) در زمینه برداشت و پردازش تصاویر سنجش از دور (تصاویر ماهواره، پهپاد، رادار و...) در خدمت صنعت بزرگ کشور عزیزمان می‌باشد.",
  contactInformation: "اطلاعات تماس",
  address: "آدرس",
  viraAddress:
    "کرمان، میدان قره نی، خیابان امام خمینی (ره) کوچه شماره یک ساختمان نیلوفر واحد 14",
  programmer: "تحلیل، طراحی و اجرای وب‌سایت",
  aliMHZ: "علی محمدحسین‌زاده",
  refresh: "بروزرسانی",
  compactView: "نمایش اطلاعات به صورت فشرده",
  ticketOpen: "در انتظار پاسخ",
  ticketInProgress: "در حال بررسی",
  ticketClosed: "پاسخ داده شد",
  view: "مشاهده",
  createNewRequest: "ایجاد درخواست جدید",
  subject: "موضوع",
  priority: "اولویت",
  description: "توضیحات",
  file: "فایل",
  ticketMaxFileSize: "حداکثر   1 مگابایت است.",
  create: "ایجاد کن",
  new: "جدید",
  ticketsHelp:
    "چنانچه در هنگام کار با سامانه به مشکلی برخورد کردید و یا سوالی درباره قسمت‌های مختلف سامانه دارید در این صفحه می‌توانید با ارسال تیکت آن را با ما در میان بگذارید.",
  row: "ردیف",
  id: "کد",
  status: "وضعیت",
  attachment: "پیوست",
  downloadAttachment: "دانلود پیوست",
  replies: "پاسخ‌ها",
  updateDate: "تاریخ بروزرسانی",
  operations: "عملیات",
  createDate: "تاریخ ایجاد",
  reply: "پاسخ",
  user: "کاربر",
  replySaved: "پاسخ جدید ایجاد شد.",
  downloadStarted: "دانلود فایل آغاز شد.",
  fileNotExist: "فایل وجود ندارد.",
  supportRequestSaved: "درخواست پشتیبانی جدید ایجاد شد.",
  ticketHelp:
    "در این صفحه تمام پیام‌های ارسالی و دریافتی درباره مشکلی که عنوان کرده‌اید را مشاهده می‌کنید.",
  viewFileContent: "مشاهده محتوای فایل",
  downloadFile: "دانلود فایل",
  logsHelp:
    "این صفحه تنها در دسترس مدیران ارشد قرار دارد.<br>تمام فایل‌های لاگ تولید شده توسط وب سرور و سامانه که حاوی اطلاعات مفیدی برای رفع مشکلات هستند در این صفحه لیست، قابل مشاهده و دانلود هستند.",
  server: "سرور",
  name: "نام",
  fileSize: "حجم فایل",
  fileContent: "محتوای فایل {0}",
  services: "سرویس‌ها",
  osHelp:
    "<p>این صفحه تنها در دسترس مدیران ارشد قرار دارد.<br />جهت رصد عملکرد سرور مقادیر اساسی زیر نمایش داده می‌شوند و به صورت لحظه‌ای بروزرسانی می‌شوند:</p><ul><li>درصد استفاده از پردازنده</li><li>درصد استفاده از حافظه</li><li>درصد فضای هارد استفاده شده</li></ul><p>همچنین در جدول سرویس‌ها، نام و وضعیت تمام سرویس‌های مورد نیاز سامانه نمایش داده می‌شوند. اگر وضعیت آن‌ها یکی از مقادیر نامعلوم، متوقف شده و یا خارج از دسترس بود بلافاصله پشتیبانی را در جریان قرار دهید.</p>",
  used: "استفاده شده",
  available: "در دسترس",
  hardSpace: "میزان فضای هارد",
  percentage: "درصد",
  usagePercentage: "درصد استفاده",
  oneMinuteInterval: "فاصله زمانی یک دقیقه",
  memoryUsage: "میزان مصرف حافظه",
  cpuUsage: "میزان مصرف CPU",
  activateAllModels: "فعال کردن همه مدل‌ها",
  disableAllModels: "غیرفعال کردن همه مدل‌ها",
  viewErrors: "مشاهده خطاها",
  edit: "ویرایش",
  delete: "حذف",
  createNewModel: "ایجاد مدل جدید",
  folder: "پوشه",
  modelCompletePath: "آدرس کامل پوشه مدل",
  change: "تغییر بده",
  no: "خیر",
  yes: "بله",
  sureToActivateModels: "آیا از فعال سازی تمام مدل‌ها مطمئن هستید؟",
  sureToDisableModels: "آیا از غیرفعال سازی تمام مدل‌ها مطمئن هستید؟",
  modelsHelp:
    "<p>این صفحه تنها در دسترس مدیران ارشد قرار دارد.<br>مدیریت مدل‌ها و خطاهای آن‌ها در این صفحه و صفحه‌های زیر مجموعه آن انجام می‌گیرد.</p><p>در هنگام ایجاد یک مدل جدید وضعیت آن مدل به صورت پیش فرض غیرفعال است. اگر وضعیت مدلی غیرفعال باشد تصاویر بارگزاری شده برای تشخیص خطا به آن مدل ارسال نخواهند شد. بهتر است پس از تعریف مدل و خطاهای مدل آن را ویرایش و فعال کنید.</p>",
  errors: "خطاها",
  active: "فعال",
  disabled: "غیرفعال",
  newModelCreated: "یک مدل جدید ایجاد شد.",
  editModel: "ویرایش مدل {0}",
  modelEdited: "مدل انتخاب شده ویرایش شد.",
  cannotDeleteModel: "قابل حذف نیست. ابتدا خطا(ها) را حذف کنید.",
  sureToDeleteModel: "آیا از حذف مدل {0} مطمئن هستید؟",
  selectAModel: "یک مدل را انتخاب کنید.",
  modelDeleted: "مدل انتخاب شده حذف شد.",
  allModelsActivated: "همه مدل‌ها فعال شدند.",
  allModelsDisabled: "همه مدل‌ها غیرفعال شدند.",
  createNewError: "ایجاد خطای جدید برای {0}",
  code: "کد",
  type: "نوع",
  thisField: "این فیلد",
  newErrorCreated: "خطای جدید ایجاد شد.",
  editError: "ویرایش خطای {0}",
  errorEdited: "خطای انتخاب شده ویرایش شد.",
  sureToDeleteError: "آیا از حذف خطای {0} مطمئن هستید؟",
  selectAnError: "یک خطا را انتخاب کنید.",
  errorDeleted: "خطای انتخاب شده حذف شد.",
  errorsHelp:
    "در این صفحه می‌توانید مشخصات خطاهای متعلق به مدل انتخاب شده را تغییر دهید. دقت کنید که کد خطا باید دقیقا همان مقداری باشد که مدل برمی‌گرداند و همچنین نمی‌تواند تکراری باشد.",
  adminTicketsHelp:
    '<p>این صفحه تنها در دسترس مدیر ارشد است.</p><p>در این صفحه لیست تمام درخواست‌های کاربران سامانه قابل مشاهده است. مدیر ارشد می‌تواند در صورت صلاحدید درخواستی را حذف کند. وضعیت درخواست پس از هر پاسخ درخواست کننده به "در انتظار پاسخ" تبدیل می‌شود.</p>',
  sureToDeleteTicket: "آیا از حذف درخواست {0} مطمئن هستید؟",
  selectATicket: "یک درخواست را انتخاب کنید.",
  ticketDeleted: "درخواست انتخاب شده حذف شد.",
  adminTicketHelp:
    '<p>این صفحه تنها در دسترس مدیر ارشد است.</p><p>زمانی که یک درخواست مشاهده شود وضعیت آن به "در حال بررسی" تغییر خواهد کرد و در صورتی که به درخواست پاسخ داده شود وضعیت به "پاسخ داده شد" تغییر خواهد کرد.</p>',
  chooseAnOption: "یک گزینه را انتخاب کنید.",
  line: "خط",
  errorType: "نوع خطا",
  errorName: "نام خطا",
  search: "جستجو",
  searchResult: "نتایج جستجو",
  searchResultOnMap: "نمایش نتایج روی نقشه",
  searchImagesHelp:
    "در این صفحه می‌توانید تصاویر با مشخصات مورد نظر را از بین تصاویر آپلود شده پیدا کنید.",
  language: "زبان",
  profileHelp:
    '<p>در این صفحه می‌توانید نام و رمز ورود خود را تغییر دهید.<br>تنها در صورتی که می‌خواهید رمز ورود خود را تغییر دهید باید تمام گزینه‌های رمز ورود را پر کنید در غیر اینصورت کافی است نام خود را تغییر داده و دکمه "تغییر مشخصات" را کلیک کنید.</p>',
  profileSaved:
    "مشخصات ذخیره شد. اگر زبان را تغییر داده‌اید لطفا خارج شوید و دوباره وارد شوید.",
  userActivitiesHelp:
    "تمامی فعالیت‌های شما در سامانه ثبت می‌شوند. در این صفحه می‌توانید لیست فعالیت‌های خود را مشاهده کنید.",
  activity: "فعالیت",
  userType: "نوع کاربر",
  namePlaceHolder: "نام کامل و یا قسمتی از آن را وارد کنید.",
  userNamePlaceHolder: "نام کاربری کامل و یا قسمتی از آن را وارد کنید.",
  contractor: "پیمانکار",
  createNewUser: "ایجاد کاربر جدید",
  privileges: "دسترسی‌ها",
  changeImageBatchStatus: "تغییر وضعیت دسته تصاویر",
  deleteError: "حذف خطا",
  userStatus: "وضعیت کاربر",
  usersHelp:
    '<p>این صفحه تنها در دسترس مدیران قرار دارد.<br>مدیر می‌تواند یک کاربر ایجاد، ویرایش و یا حذف کند. اگر کاربری دسته تصاویری را آپلود کرده باشد تا زمانی که آن دسته موجود باشد، آن کاربر قابل حذف نیست.</p><p>اگر نوع کاربر یکی از انواع کارفرما انتخاب شود، فیلد کارفرما و انتخاب آن الزامی خواهد بود. همینطور اگر نوع کاربر یکی از انواع پیمانکار انتخاب شود انتخاب هر دو فیلد کارفرما و پیمانکار الزامی خواهند بود.</p><p>در هنگام ویرایش مشخصات کاربر تنها در صورتی که نیاز به تغییر رمز ورود دارید آن را وارد کنید در غیر اینصورت نیازی به وارد کردن آن نیست. همچنین اگر کاربری قابل حذف نیست و دسترسی آن به سیستم باید بسته شود می‌توانید آن کاربر را غیر فعال کنید. کاربر غیر فعال شده نمی‌تواند وارد سامانه بشود.</p><p>علاوه بر نوع کاربر که هر نوع محدودیت و دسترسی‌های خاص خود را دارد، دسترسی‌هایی برای کاربران تعریف شده‌است که برای فعال کردن آن‌ها باید بخش "دسترسی‌ها" را هنگام ایجاد/ویرایش کاربر انتخاب کنید.</p>',
  superAdmin: "مدیر ارشد",
  admin: "مدیر",
  employerExpert: "کارفرما-کارشناس",
  employerManager: "کارفرما-مدیر",
  contractorPilot: "پیمانکار-خلبان",
  contractorExpert: "پیمانکار-کارشناس",
  contractorManager: "پیمانکار-مدیر",
  newUserCreated: "کاربر جدید ایجاد شد.",
  editUser: "ویرایش کاربر {0}",
  userEdited: "کاربر انتخاب شده ویرایش شد.",
  sureToDeleteUser: "آیا از حذف کاربر {0} مطمئن هستید؟",
  selectAUser: "یک کاربر را انتخاب کنید.",
  userDeleted: "کاربر انتخابی حذف شد.",
  operationDescription: "توضیح عملیات",
  date: "تاریخ",
  downloadExcel: "دانلود نتیجه جستجو به فرمت اکسل",
  searchActivitiesHelp:
    "<p>این صفحه تنها در دسترس مدیران ارشد قرار دارد.<br>در این صفحه مدیر می‌تواند فعالیت‌های تمام کاربران را با انتخاب یک یا چندین گزینه جستجو کند.</p><ul><li>کاربر</li><li>عملیات: نوع فعالیت انجام شده</li><li>IP: آدرس کامل و یا قسمتی از IP کاربر</li><li>توضیحات: کلید واژه</li><li>تاریخ: بازه زمانی</li></ul><p>نتایج جستجو می تواند به صورت فایل اکسل دانلود بشوند.</p>",
  changePassword: "تغییر رمز ورود",
  resetPassword: "تنظیم مجدد رمز ورود",
  insert: "ایجاد",
  upload: "آپلود",
  download: "دانلود",
  ip: "IP",
  atLeastOneOption: "حداقل یک گزینه را وارد/انتخاب کنید.",
  pageNumber: "شماره صفحه",
  highQuality: "کیفیت بالا",
  reportInPDF: "گزارش به فرمت PDF",
  reportInExcel: "دانلود گزارش به فرمت اکسل",
  reportInKMZ: "دانلود گزارش به فرمت KMZ",
  viewOperations: "مشاهده عملیات",
  changeStatus: "تغییر وضعیت",
  dataEntry: "ورود اطلاعات",
  waitingToCreate: "در انتظار شروع ساخت",
  creatingExcel: "در حال ساخت فایل اکسل",
  creatingPDF: "در حال ساخت فایل PDF",
  creatingKMZ: "در حال ساخت فایل KMZ",
  finished: "اتمام ایجاد",
  changeStatusToStart: "تغییر به وضعیت در انتظار شروع ساخت",
  adminReportsHelp:
    '<p>این صفحه تمام گزارش‌هایی که توسط کاربران در سامانه ایجاد شده‌اند را نمایش می‌دهد. گزارش ایجاد شده علاوه بر اینکه روی نقشه قابل نمایش است به فرمت های قابل دانلود pdf, اکسل و kmz که قابل بارگزاری در برنامه Google Earth است ساخته می‌شود.</p><p>برای هر برج یک فایل pdf جداگانه مخصوص آن برج ایجاد می‌شود که با انتخاب "گزارش به فرمت pdf" فایل‌های تولید شده متناظر هر برج نمایش داده شده و قابل دانلود هستند.</p><p>در صورتی که به هر دلیل نیاز باشد تا فایل‌های گزارش مجدد تولید شوند با انتخاب دکمه "ساعت شنی" و سپس انتخاب "تغییر به وضعیت در انتظار شروع ساخت" گزارش در صف ایجاد قرار خواهد گرفت.</p>',
  title: "عنوان",
  specifications: "مشخصات",
  sureToDeleteReport: "آیا از حذف گزارش {0} مطمئن هستید؟",
  selectAReport: "یک گزارش را انتخاب کنید.",
  reportDeleted: "گزارش انتخابی حذف شد.",
  reportPDFFiles: "فایل‌های pdf گزارش {0}",
  changeReportStatus: "تغییر وضعیت {0}",
  reportStatusChanged: "تغییر وضعیت گزارش انتخابی ثبت شد.",
  adminReportLogsHelp:
    "تمامی عملیاتی که روی یک گزارش توسط تمام افرادی که به آن گزارش دسترسی دارند ذخیره و در این صفحه نمایش داده می‌شود.",
  zoomIn: "بزرگ‌نمایی",
  zoomOut: "کوچک‌نمایی",
  fullscreen: "تمام صفحه",
  summaryErrors: "چکیده معایب",
  adminReportOnMapHelp:
    "این صفحه برج‌های خط گزارش انتخاب شده را به همراه تعداد خطاهای آن روی نقشه نمایش می‌دهد. با انتخاب یک برج لیستی از خطاها و تصاویر مربوطه نمایش داده می‌شود.",
  map: "نقشه",
  receivingInformation: "در حال دریافت اطلاعات",
  reportOfCode: "گزارش برج {0} کد {1}",
  searchFolderName: "جستجوی نام پوشه",
  update: "بروزرسانی",
  towerView: "نمای برج",
  towerType: "نوع برج",
  imagesWithError: "تصاویر حاوی خطا",
  imagesWithoutError: "تصاویر بدون خطا",
  selectAFolder: "یک پوشه را انتخاب کنید.",
  errorsList: "لیست خطاها",
  fromExcelFile: "از فایل اکسل",
  selectExcelFile: "یک فایل اکسل انتخاب کنید.",
  changeTowerType: "تغییر نوع برج",
  selectTowerType: "لطفا نوع برج‌ها را انتخاب کنید.",
  changeTowerView: "تغییر نمای برج",
  selectJPGFile: "یک فایل JPG انتخاب کنید.",
  adminImagesHelp:
    "<p>در این صفحه می‌توانید تصاویر بارگذاری شده یک دسته را مشاهده کنید.<br>تصاویر بر اساس ساختار پوشه بندی که داشتند ذخیره شده‌اند. در ساختار درختی با انتخاب هر پوشه، پوشه‌های داخلی آن نمایش داده می‌شوند. همچنین با انتخاب پوشه اولیه یا همان برج، تصاویر نمای برج و نوع برج نمایش داده می‌شوند. جهت یافتن یک پوشه خاص کافی است در کادر جستجو نام آن را (حساس به حروف بزرگ و کوچک) تایپ کنید. با انتخاب پوشه‌ای که تصاویر در آن قرار دارند، تصاویر آن پوشه در سمت چپ نمایش داده می‌شوند.</p><p>جهت مشاهده تصویر در اندازه اصلی روی آن کلیک کنید. در پنجره باز شده در سمت راست در جدول خطاهای تشخیص داده شده نمایش داده می‌شوند و در صورت داشتن دسترسی لازم می‌توانید خطا(های) نادرست را حذف کنید. در سمت چپ، تصویر با اندازه اصلی نمایش داده میشود که به روش‌های زیر می‌توانید تصویر را بزرگ/کوچک نمایی کنید:</p><ul><li>دوبار کلیک: با انجام عمل دوبار کلیک (دابل کلیک) در نقطه مورد نظر تصویر بزرگ نمایی می‌شود و با انجام دوباره این کار تصویر به حالت اولیه برمی‌گردد.</li><li>چرخ موس: با چرخاندن چرخ موس به سمت بالا و پایین به ترتیب در جایی که نشانگر موس وچود دارد عمل بزرگ نمایی و کوچک نمایی انجام می‌شود.</li></ul><p>پس از بزرگ نمایی با انجام عمل کشیدن تصویر و رها کردن آن می‌توانید تمام نقاط تصویر را مشاهده کنید.</p>",
  coordinates: "مختصات",
  showImageFullsize: "نمایش تصویر {0} در اندازه واقعی",
  errorDeletedQueue:
    "خطای انتخابی حذف شد و تصویر در صف بروزرسانی برچسب‌ها قرار گرفت.",
  towerTypeEdited: "نوع برج انتخاب شده ویرایش شد.",
  fileUploaded: "فایل آپلود شد.",
  fileUploadedErrorsCreated: "فایل آپلود و خطاها ایجاد شدند.",
  adminBatchLogsHelp:
    "تمامی عملیاتی که روی یک دسته تصاویر توسط تمام افرادی که دسترسی دارند ذخیره و در این صفحه نمایش داده می‌شود.",
  deleteAllErrors: "حذف تمام خطاها",
  showErrors: "نمایش خطاها",
  hideErrors: "عدم نمایش خطاها",
  viewImages: "مشاهده تصاویر",
  loading: "در حال بارگذاری",
  captureDate: "تاریخ عکس‌برداری",
  files: "تعداد فایل‌ها",
  of: "از",
  sureToDeleteBatch: "آیا از حذف دسته {0} مطمئن هستید؟",
  selectABatch: "یک دسته را انتخاب کنید",
  batchDeleted: "دسته انتخابی حذف شد.",
  deleteAllBatchErrors: "آیا از حذف تمام خطاهای دسته {0} مطمئن هستید؟",
  batchErrorsDeleted: "خطاهای دسته انتخابی حذف شدند.",
  changeBatchStatus: "تغییر وضعیت کد {0}",
  batchStatusChangeSaved: "تغییر وضعیت دسته انتخابی ذخیره شد.",
  errorsWillDispalyed: "خطاها نمایش داده خواهد شد.",
  errorsWillHidden: "خطاها پنهان خواهند شد.",
  uploading: "در حال آپلود",
  uploadingFinished: "اتمام آپلود",
  waitingToStartDiagnosis: "انتظار شروع تشخیص",
  diagnosing: "در حال تشخیص",
  diagnosingFinished: "اتمام تشخیص",
  changeStatusToDiagnose: "تغییر به وضعیت در انتظار شروع تشخیص",
  viewLines: "مشاهده خط‌ها",
  viewUsers: "مشاهده کاربرها",
  viewContractors: "مشاهده پیمانکارها",
  createNewEmployer: "ایجاد کارفرما جدید",
  logo: "لوگو",
  logoPlaceHolder: "فایل jpg, jpeg, png, bmp با حداکثر حجم 500 کیلوبایت",
  employersHelp:
    "<p>این صفحه تنها در دسترس مدیران قرار دارد.<br>مدیریت کارفرماها، پیمانکارها، خط‌ها و برج‌ها در این صفحه و صفحه‌های زیر مجموعه آن انجام می‌گیرد.</p><p>در هنگام ایجاد کارفرما، انتخاب لوگو الزامی است اما در ویرایش تنها در صورتی لوگو را انتخاب کنید که قصد جایگزین کردن لوگوی اولیه را دارید.</p><p>فایل انتخابی برای لوگو باید حداکثر 500 کیلوبایت و یکی از انواع زیر باشد:<br>jpg, jpeg, bmp, png</p>",
  newEmployerCreated: "کارفرما جدید ایجاد شد.",
  editEmployer: "ویرایش کارفرما {0}",
  employerEdited: "کارفرما انتخاب شده ویرایش شد.",
  cannotDeleteEmployer:
    "قابل حذف نیست. ابتدا کاربر/پیمانکار/خط(ها) را حذف کنید.",
  sureToDeleteEmployer: "آیا از حذف کارفرما {0} مطمئن هستید؟",
  selectAnEmployer: "یک کارفرما را انتخاب کنید",
  employerDeleted: "کارفرما انتخابی حذف شد.",
  showUsers: "نمایش کاربران {0}",
  createNewContractorFor: "ایجاد پیمانکار جدید برای {0}",
  contractExpiration: "انقضا قرارداد",
  adminContractorsHelp:
    '<p>در این صفحه می‌توانید مشخصات پیمانکاران کارفرمای انتخاب شده را تغییر دهید. همچنین جهت مشاهده کاربران یک پیمانکار، دکمه "مشاهده کاربرها" روبروی پیمانکار دلخواه را انتخاب کنید.</p><p>لطفا توجه کنید که کاربران یک پیمانکار پس از پایان تاریخ انقضا قرارداد نمی‌توانند وارد سیستم بشوند.</p>',
  newContractorCreated: "پیمانکار جدید ایجاد شد.",
  editContractor: "ویرایش پیمانکار {0}",
  contractorEdited: "پیمانکار انتخاب شده ویرایش شد.",
  cannotDeleteContractor: "قابل حذف نیست. ابتدا کاربر(ها) را حذف کنید.",
  sureToDeleteContractor: "آیا از حذف پیمانکار {0} مطمئن هستید؟",
  selectAContractor: "یک پیمانکار را انتخاب کنید",
  contractorDeleted: "پیمانکار انتخابی حذف شد.",
  emploerContractorsHelp:
    'در این صفحه مشخصات تمامی پیمانکاران زیر مجموعه خود را می‌توانید مشاهده کنید. همچنین جهت نمایش مشخصات اعضا یک پیمانکار خاص می‌توانید با انتخاب دکمه "مشاهده کاربرها" روبروی هر پیمانکار لیست کابرهای آن پیمانکار را مشاهده کنید.',
  importFromExcel: "ورود داده از فایل اکسل",
  viewTowers: "مشاهده برج‌ها",
  downloadLineTowersKMZ: "دانلود خط و برج‌ها به فرمت KMZ",
  viewTowersOnMap: "مشاهده برج‌ها روی نقشه",
  createNewLineFor: "ایجاد خط جدید برای {0}",
  origin: "مبدا",
  destination: "مقصد",
  singleCircuitLength: "طول تک مداره",
  single: "",
  dualCircuitLength: "طول دو مداره",
  dual: "دو",
  fourCircuitLength: "طول چهار مداره",
  four: "چهار",
  sixCircuitLength: "طول شش مداره",
  six: "شش",
  eightCircuitLength: "طول هشت مداره",
  eight: "هشت",
  voltageLevel: "سطح ولتاژ",
  history: "تاریخچه",
  selectADate: "یک تاریخ را انتخاب کنید",
  importEmployerLinesExcel: "ورود خطوط {0}} از فایل اکسل",
  sampleFile: "فایل نمونه",
  linesHelp:
    '<p>در این صفحه می‌توانید مشخصات خطوط متعلق به کارفرمای انتخاب شده را تغییر دهید. همچنین جهت مدیریت برج‌های خط انتخابی دکمه "مشاهده برج‌ها" روبروی خط مورد نظر را انتخاب کنید. جهت مشاهده تمام برج‌های خط مورد نظر بر روی نقشه دکمه "مشاهده برج‌ها روی نقشه" روبروی خط دلخواه را انتخاب کنید.</p><p>رنگ خطوط بین برج‌ها بر اساس مقدار سطح ولتاژ خط تعین می‌شود:</p><ul><li>آبی: کمتر مساوی 63</li><li>سبز: بیشتر از 63 و کمتر مساوی 132</li><li>قرمز: بیشتر از 132 و کمتر از 230</li><li>بنفش: بیشتر از 230</li></ul><p>در صورتی که اطلاعات خط(ها) را دارید می‌توانید با تبدیل این اطلاعات به یک فایل اکسل آن‌ها را وارد برنامه کنید. ساختار فایل اکسل ارسالی باید همانند فایل نمونه باشد. برای دانلود فایل اکسل نمونه دکمه "فایل نمونه" را انتخاب کنید. همچنین نیازی به ردیف اول به عنوان اسامی ستون‌ها نیست و این سطر باید حذف شود.</p>',
  circuitLength: "طول مدار",
  batches: "دسته‌ها",
  newLineCreated: "خط جدید ایجاد شد.",
  editLine: "ویرایش خط {0}",
  lineEdited: "خط انتخاب شده ویرایش شد.",
  cannotDeleteLine: "قابل حذف نیست. ابتدا برج/دسته(ها) را حذف کنید.",
  sureToDeleteLine: "آیا از حذف خط {0} مطمئن هستید؟",
  selectALine: "یک خط را انتخاب کنید",
  lineDeleted: "خط انتخابی حذف شد.",
  showLineTowers: "نمایش برج‌های خط {0}}",
  fileUploadedLinesCreated: "فایل آپلود شد و خط‌ها ایجاد شدند.",
  createNewTowerFor: "ایجاد برج جدید برای {0}",
  towersHelp:
    '<p>در این صفحه می‌توانید مشخصات برج‌های خط انتخاب شده را تغییر دهید.<br>مقدار کد هر برج بسیار مهم است زیرا در بارگزاری تصاویر نام پوشه برج باید با کد برج که در اینجا وارد می‌کنید یکی باشند.</p><p>توجه کنید که در هنگام ورود اطلاعات دقت لازم را برای مقادیر صحیح طول و عرض جغرافیایی لحاظ کنید. برای تعیین این مقادیر می‌توانید اعداد مورد نظر را تایپ کنید و یا روی نقشه در محل مناسب کلیک کنید.</p><p>در صورتی که اطلاعات برج(ها) را دارید می‌توانید با تبدیل این اطلاعات به یک فایل اکسل آن‌ها را وارد برنامه کنید. ساختار فایل اکسل ارسالی باید همانند فایل نمونه باشد. برای دانلود فایل اکسل نمونه دکمه "فایل نمونه" را انتخاب کنید. همچنین نیازی به ردیف اول به عنوان اسامی ستون‌ها نیست و این سطر باید حذف شود.</p><p>در صورتی که برج‌ها ایجاد نشده باشند، با آپلود دسته تصاویر برای یک خط برج‌ها ایجاد خواهند شد. همچنین اگر طول و عرض جغرافیایی برای آن‌ها ثبت نشده باشد، با آپلود اولین تصویری که شامل این اطلاعات باشد طول و عرض جغرافیایی برج بروزرسانی خواهد شد.</p>',
  newTowerCreated: "برج جدید ایجاد شد.",
  editTower: "ویرایش برج {0}",
  towerEdited: "برج انتخاب شده ویرایش شد.",
  sureToDeleteTower: "آیا از حذف برج {0} مطمئن هستید؟",
  selectATower: "یک برج را انتخاب کنید",
  towerDeleted: "برج انتخابی حذف شد.",
  fileUploadedTowersCreated: "فایل آپلود شد و برج‌ها ایجاد شدند.",
  colleaguesHelp: "در این صفحه مشخصات تمامی همکاران خود را مشاهده می‌کنید.",
  sendNewImages: "ارسال تصاویر جدید",
  uploadHelp:
    '<p>جهت آپلود یا بارگزاری تصاویر ابتدا خطی که تصاویر متعلق به آن هستند را انتخاب کنید، بعد از آن تاریخی که در آن عکس‌برداری انجام شده‌است را وارد کنید. سپس پوشه عکس‌ها را انتخاب کرده و در انتها نوع برج‌ها را از بین تصاویر نمایش داده شده انتخاب کنید.</p><p>داخل پوشه‌ای که انتخاب می‌کنید بایستی برای هر برج یک پوشه با نام آن برج که کد آن است وجود داشته باشد. داخل پوشه هر برج نیز بایستی برای قسمت‌های مختلف برج، پوشه‌ای با نام‌های مشخص شده (همانند اسامی که در تصویر نوع برج وجود دارد) قرار داشته باشد و در انتها در آن پوشه تصاویر وجود داشته باشند. همچنین اگر در پوشه برج یک فایل از نوع jpg وجود داشته باشد به عنوان تصویر برج انتخاب خواهد شد. توجه کنید که این تصویر به تشخیص ارسال نخواهد شد.</p><p>پس از انتخاب دکمه ارسال، تصاویر یکی یکی ارسال خواهند شد و نوار پیشرفتی نمایش داده می‌شود که روی آن دو عدد نمایش داده خواهد شد. عدد اول درصد ارسال کل تصاویر و عدد دوم درصد پیشرفت ارسال تصویر جاری است. هر تصویر که ارسال می‌شود نام و وضعیت نهایی ارسال آن در جدول پایین اضافه خواهد شد. پس از ارسال همه تصاویر در صورتی که دسته دیگری از تصاویر را باید ارسال کنید کافی است دکمه "ارسال تصاویر جدید" را انتخاب کنید.</p>',
  successful: "موفق",
  sent: "ارسال شد",
  uploadCompleted: "عملیات آپلود به اتمام رسید.",
  incorrectFolderStructure: "ساختار پوشه‌ها اشتباه است.",
  folderSelected: 'پوشه "{0}" با {1} فایل انتخاب شده است.',
  continueUploadingImages: "ادامه آپلود تصاویر",
  adminUploadsHelp:
    '<p>این صفحه تمام دسته‌های تصاویری که توسط کاربران در سامانه آپلود شده‌اند را نمایش می‌دهد. علاوه بر نمایش تصاویر در صورت لزوم می‌توان دسته‌ها را پاک کرد.</p><p>اگر برای دسته تصاویری خطا تشخیص داده شده باشد، برای حذف آن تصاویر ابتدا بایستی تمام خطاها حذف شوند تا بتوان دسته تصاویر را حذف کرد. دقت کنید که حذف تصاویر عملی غیر قابل بازگشت است.</p><p>در صورتی که نیاز باشد تا دسته تصاویر آپلود شده دوباره به تشخیص ارسال شوند، با انتخاب ساعت شنی و سپس انتخاب دکمه "تغییر وضعیت به وضعیت در انتظار شروع تشخیص" این کار انجام خواهد شد. خطاهای تکراری ثبت نخواهند شد.</p>',
  uploadsHelp:
    '<p>این صفحه تمام دسته‌های تصاویری که توسط شما و یا همکاران شما در سامانه آپلود شده‌اند را نمایش می‌دهد.</p><p>در صورتی که به هر دلیلی در آپلود تصاویر به انتها نرسد و یا آپلود یک یا چند فایل با خطا مواجه شود، در این صفحه روبروی دسته تصویر دکمه "ادامه آپلود تصاویر" نمایش داده می‌شود که با انتخاب آن می‌توان آپلود تصاویر را از سر گرفت.</p><p>پس از اتمام آپلود وضعیت دسته به "اتمام بارگذاری" تغییر می‌کند و تا زمانی که کاربر وضعیت دسته را به "در انتظار شروع تشخیص" تغییر ندهد، تصاویر برای تشخیص ارسال نخواهند شد. همچنین در صورتی که نیاز باشد تا دسته تصاویر آپلود شده دوباره به تشخیص ارسال شوند، با انتخاب ساعت شنی و سپس انتخاب دکمه "تغییر وضعیت به وضعیت در انتظار شروع تشخیص" این کار انجام خواهد شد. خطاهای تکراری ثبت نخواهند شد.</p>',
  imagesHelp:
    '<p>در این صفحه می‌توانید تصاویر بارگذاری شده یک دسته را مشاهده کنید.<br>تصاویر بر اساس ساختار پوشه بندی که داشتند ذخیره شده‌اند. در ساختار درختی با انتخاب هر پوشه، پوشه‌های داخلی آن نمایش داده می‌شوند. جهت یافتن یک پوشه خاص کافی است در کادر جستجو نام آن را تایپ کنید. با انتخاب پوشه‌ای که تصاویر در آن قرار دارند، تصاویر آن پوشه در سمت چپ نمایش داده می‌شوند.</p><p>جهت مشاهده تصویر در اندازه اصلی روی آن کلیک کنید. در پنجره باز شده در سمت راست در جدولی خطاهای تشخیص داده شده نمایش داده می‌شوند و در صورت داشتن دسترسی لازم می‌توانید خطا(های) نادرست را حذف کنید. در سمت چپ تصویر با اندازه اصلی نمایش داده میشود که به روش‌های زیر می‌توانید تصویر را بزرگ/کوچک نمایی کنید:</p><ul><li>Double-click: By double-clicking (double-clicking), the image will be magnified at the desired point, and by doing this again, the image will return to its original state.</li><li>چرخ موس: با چرخاندن چرخ موس به سمت بالا و پایین به ترتیب در جایی که نشانگر موس وچود دارد عمل بزرگ نمایی و کوچک نمایی انجام می‌شود.</li></ul><p>پس از بزرگ نمایی با انجام عمل کشیدن تصویر و رها کردن آن می‌توانید تمام نقاط تصویر را مشاهده کنید.</p><p>در ساختار درختی با انتخاب پوشه اولیه یا همان برج، نمای برج و نوع برج نمایش داده می‌شوند. در صورتی که وجود نداشته باشند و یا نیاز به تغییر آن‌ها باشد با انتخاب دکمه "بروزرسانی" میتوان تصویر جدیدی برای برج آپلود و یا نوع دیگری برای برج انتخاب کرد.</p>',
  batchLogsHelp:
    "تمامی عملیاتی که روی یک دسته تصاویر توسط تمام افرادی که دسترسی دارند ذخیره و در این صفحه نمایش داده می‌شود.",
  createNewReport: "ایجاد گزارش جدید",
  batchOfImages: "دسته تصاویر",
  selectBatchOfImages: "دسته ای از تصاویر را انتخاب کنید",
  firstPageText: "متن صفحه اول",
  reportsHelp:
    '<p> این صفحه تمام گزارش‌هایی که توسط شما و همکارانتان در سامانه ایجاد شده‌اند را نمایش می‌دهد. گزارش ایجاد شده علاوه بر اینکه روی نقشه قابل نمایش است به فرمت های قابل دانلود pdf, اکسل و kmz که قابل بارگزاری در برنامه Google Earth است نیز ساخته می‌شود.</p><p>برای هر برج یک فایل pdf جداگانه مخصوص آن برج ایجاد می‌شود که با انتخاب "گزارش به فرمت pdf" فایل‌های تولید شده متناظر هر برج نمایش داده شده و قابل دانلود هستند.</p><p>در هنگام ایجاد/ویرایش یک گزارش علاوه بر امکان انتخاب دسته تصاویر، عنوان و متن صفحه اول را می‌توانید مشخص کنید که از تصاویر با کیفیت بالا در تولید فایل‌های گزارش استفاده بشود یا تصاویر با کیفیت پایین. همچنین می‌توانید چاپ شدن یا نشدن شماره صفحه در تولید فایل pdf گزارش را کنترل کنید.</p><p>پس از ایجاد/ویرایش گزارش وضعیت آن به حالت "ورود اطلاعات" تبدیل خواهد شد و تا زمانی که کاربر وضعیت آن را به "در انتظار شروع ساخت" تغییر ندهد، فایل‌های گزارش ایجاد نخواهند شد.</p>',
  newReportCreated: "گزارش جدید ایجاد شد.",
  editReport: "ویرایش گزارش {0}",
  reportEdited: "گزارش انتخاب شده ویرایش شد.",
  reportLogsHelp:
    "تمامی عملیاتی که روی یک گزارش توسط تمام افرادی که دسترسی دارند ذخیره و در این صفحه نمایش داده می‌شود.",
  reportOnMapHelp:
    "این صفحه برج‌های خط گزارش انتخاب شده را به همراه تعداد خطاهای آن روی نقشه نمایش می‌دهد. با انتخاب یک برج لیستی از خطاها و تصاویر مربوطه نمایش داده می‌شود.",
  continueUploadHelp:
    'شما به این دلیل که به هر علتی عملیات آپلود فایل به انتها نرسیده است در این صفحه هستید. برای ادامه آپلود کافی است تا پوشه تصاویری را که در قسمت "ارسال تصاویر" انتخاب کردید را انتخاب کنید. تصاویری که قبلا ارسال شده‌اند مجدد به سرور ارسال نخواهند شد.',
  securityCode: "کد امنیتی",
  newSecurityCode: "کد امنیتی جدید",
  updateAvailable: "ویرایش جدید برنامه آماده است",
  validations: {
    required: "ورود {0} الزامی است.",
    len: "طول {0} {1} کاراکتر است.",
    min: "حداقل طول {0} {1} کاراکتر است.",
    max: "حداکثر طول {0} {1} کاراکتر است.",
    maxFileSize: "حجم فایل {0} باید کمتر از {1} مگابایت باشد.",
    sameValue: "مقدار {0} و {1} باید یکسان باشد."
  },
  badge: "نشان",
  close: "بستن",
  dataIterator: {
    noResultsText: "نتیجه‌ای یافت نشد.",
    loadingText: "در حال بارگذاری..."
  },
  dataTable: {
    itemsPerPageText: "ردیف در صفحه:",
    ariaLabel: {
      sortDescending: "مرتب‌سازی نزولی",
      sortAscending: "مرتب‌سازی صعودی",
      sortNone: "بدون مرتب‌سازی",
      activateNone: "غیرفعال‌سازی مرتب‌سازی",
      activateDescending: "غیرفعال‌سازی مرتب‌سازی نزولی",
      activateAscending: "غیرفعال‌سازی مرتب‌سازی صعودی"
    },
    sortBy: "مرتب‌سازی براساس"
  },
  dataFooter: {
    itemsPerPageText: "ردیف در صفحه:",
    itemsPerPageAll: "همه",
    nextPage: "صفحه‌ی بعد",
    prevPage: "صفحه‌ی قبل",
    firstPage: "صفحه‌ی یکم",
    lastPage: "صفحه‌ی آخر",
    pageText: "{0} تا {1} از {2}"
  },
  datePicker: {
    itemsSelected: "{0} انتخاب شده",
    nextMonthAriaLabel: "ماه بعد",
    nextYearAriaLabel: "سال بعد",
    prevMonthAriaLabel: "ماه قبل",
    prevYearAriaLabel: "سال قبل"
  },
  noDataText: "داده‌ای موجود نیست.",
  carousel: {
    prev: "اسلاید قبلی",
    next: "اسلاید بعدی",
    ariaLabel: {
      delimiter: "اسلاید {0} از {1}"
    }
  },
  calendar: {
    moreEvents: "{بیشتر {0"
  },
  fileInput: {
    counter: "{0} پرونده",
    counterSize: "{0} پرونده ({1} در کل)"
  },
  timePicker: {
    am: "قبل از ظهر",
    pm: "بعد از ظهر"
  },
  pagination: {
    ariaLabel: {
      wrapper: "جهت یابی صفحه",
      next: "صفحه بعد",
      previous: "صفحه قبلی",
      page: "برو صفحه {0}",
      currentPage: "{0} صفحه فعلی ، صفحه"
    }
  },
  rating: {
    ariaLabel: {
      icon: "Rating {0} of {1}"
    }
  }
};
//# sourceMappingURL=fa.js.map
